import React from 'react';
import { ErrorCode } from '../../../dtos/error-message.dto';
import useCustomModal from '../custom-modal/custom-modal';
import { ErrorDetails, errorsMap } from './errors-map';
import { toast } from '../toast-notifications';
import { NotificationType } from '../../../utils/enums';

export interface PromiseFeedback {
    promise: Promise<any>;
    successCallback?: (res: any) => any;
    errorCallback?: (res: any) => any;
    specialSuccessCode?: number;
    notifObj?: { show?: boolean, notificationMsg?: string };
    modalObj?: any;
    // Per-status overrides of the default errorsMap entries, keyed by HTTP status code
    errorsOverride?: Record<string, ErrorDetails>;
}

const usePromiseFeedback = (): [(context: PromiseFeedback) => void, React.ReactElement] => {

    const [showModal, showErrorModal, contextHolder] = useCustomModal();

    const promiseFeedbackFactory = (context: PromiseFeedback) => {
        context.promise.then((res) => {
            context.successCallback?.(res);

            if ((!context.specialSuccessCode || res?.status !== context.specialSuccessCode)
                && context?.notifObj?.show !== false) {
                toast(NotificationType.SUCCESS,
                    context?.notifObj?.notificationMsg ?? 'Action was completed successfully');
            }
        }, (error_) => {
            console.error(error_); // until send real log we need to know what the problem
            context.errorCallback?.(error_);

            const statusKey = error_?.response?.status?.toString();
            const errorDetails = context.errorsOverride?.[statusKey] ?? errorsMap[statusKey];

            if (errorDetails) {
                showModal({
                    title: errorDetails.title,
                    body: () => <p data-testid="error-message">{errorDetails.message || error_.response.data?.errorMessage}</p>,
                    centered: true,
                    className: 'error-modal',
                    okText: errorDetails.okText,
                    icon: null,
                    ...context.modalObj
                });
            } else if (error_?.response?.status !== ErrorCode.UNAUTHENTICATED && error_?.response?.status !== ErrorCode.UNAUTHORIZED) {
                showErrorModal(context.modalObj);
            }
        });
    };

    return [promiseFeedbackFactory, contextHolder];
};

export default usePromiseFeedback;
